import { render, staticRenderFns } from "./stockAvailabilityByCategoryAndSegment.vue?vue&type=template&id=1f1ab30d&"
import script from "./stockAvailabilityByCategoryAndSegment.vue?vue&type=script&lang=js&"
export * from "./stockAvailabilityByCategoryAndSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports